export default "__VITE_ASSET__CosH_RoU__"